(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  
  $(document).ready(() => {
    let $footerMenuDetails = $('.footer-menu__item-details');

    function toggleFooterItems($details) {
      let winWidth = window.innerWidth
                    || document.documentElement.clientWidth
                    || document.body.clientWidth;

      if (winWidth >= 750) {
        $details.each(function(){
          $(this).get(0).open = true;
        });
      } else {
        $details.each(function(){
          $(this).get(0).open = false;
        });
      }
    }
    
    if ($footerMenuDetails.length) {
      $(window).on('resize', () => {
        toggleFooterItems($footerMenuDetails);
      });

      $(window).on('load', () => {
        toggleFooterItems($footerMenuDetails);
      });

      toggleFooterItems($footerMenuDetails);
    }


    $(window).on('load', ()=> {
      const productSection = document.querySelector('.shopify-section-product');
      const globoTopBlock = document.querySelector('.globoRecommendationsTop');

      if(productSection && globoTopBlock) {
        watchGloboCrossSellSlider();
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function getHeaderHeight(header, announcement) {
    let currentHeaderHeight = 0;

    if (header) {
      currentHeaderHeight += header.offsetHeight;
    }

    if (announcement) {
      currentHeaderHeight += announcement.offsetHeight;
    }

    return currentHeaderHeight;
  }

  function getMobileMenuHeight(nav, utilities) {
    let currentMobileMenuHeight = 0;

    if (nav) {
      currentMobileMenuHeight += nav.offsetHeight;
    }

    if (utilities) {
      currentMobileMenuHeight += utilities.offsetHeight;
    }

    return currentMobileMenuHeight;
  }

  window.addEventListener('DOMContentLoaded', () => {
    const siteHeader = document.getElementById('shopify-section-header');
    const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');
    let resizeTimeout = null;

    if (siteHeader || siteAnnouncement) {
      resizeTimeout = setTimeout(() => {
        document.documentElement.style.setProperty('--current-header-height', parseInt(getHeaderHeight(siteHeader, siteAnnouncement)) +'px');
      }, 1000);
      

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          document.documentElement.style.setProperty('--current-header-height', parseInt(getHeaderHeight(siteHeader, siteAnnouncement)) +'px');
        }, 500);
      });
    }

    const mobileMenu = document.querySelector('.header--has-menu .menu-drawer__navigation');
    const utilities = document.querySelector('.header--has-menu .menu-drawer__utility-links');

    if (mobileMenu) {
      document.documentElement.style.setProperty('--current-mobile-menu-height', parseInt(getMobileMenuHeight(mobileMenu, utilities)) +'px');

      window.addEventListener('resize', () => {
        document.documentElement.style.setProperty('--current-mobile-menu-height', parseInt(getMobileMenuHeight(mobileMenu, utilities)) +'px');
      });
    }

    const megaMenuLinks = document.querySelectorAll('.mega-menu__list--sidebar-media li[data-menu-item-id]');
    const megaMenuMedia = document.querySelectorAll('.mega-menu__media[data-menu-item-id]');
    const megaMenuDefaultMedia = document.querySelectorAll('.mega-menu__media--default');
    const megaMenuTopLevelMedia = document.querySelectorAll('.mega-menu__media--top');

    let megaSubmenuTimeout;
    let megaSubmenuTimeout2;

    if (megaMenuLinks.length && megaMenuMedia.length) {
      megaMenuLinks.forEach(item => {
        item.addEventListener('mouseenter', event => {
          clearTimeout(megaSubmenuTimeout);

          megaMenuLinks.forEach(megaMenuItem => {
            if (!megaMenuItem.contains(item)) {
              megaMenuItem.classList.remove('active');
            }
          });

          item.classList.add('active');
          
          const id = item.dataset.menuItemId;
          const media = document.querySelector('.mega-menu__media[data-menu-item-id="'+ id +'"]');
          const activeMedia = document.querySelectorAll('.mega-menu__media--on');

          if (activeMedia.length) {
            activeMedia.forEach(activeItem => {
              activeItem.classList.remove('mega-menu__media--on');
            });
          }

          if (!id || !media) {
            if (megaMenuTopLevelMedia.length) {
              megaMenuTopLevelMedia.forEach(topLevelItem => {
                topLevelItem.classList.remove('mega-menu__media--off');
              });
            } else if (megaMenuDefaultMedia.length) {
              megaMenuDefaultMedia.forEach(defaultItem => {
                defaultItem.classList.remove('mega-menu__media--off');
              });
            }
          } else {
            if (megaMenuDefaultMedia.length) {
              megaMenuDefaultMedia.forEach(defaultItem => {
                defaultItem.classList.add('mega-menu__media--off');
              });
            }
  
            if (megaMenuTopLevelMedia.length) {
              megaMenuTopLevelMedia.forEach(topLevelItem => {
                topLevelItem.classList.add('mega-menu__media--off');
              });
            }
            
            media.classList.add('mega-menu__media--on');
          }
        });

        item.addEventListener('mouseleave', event => {
          megaSubmenuTimeout = setTimeout(() => {
            megaMenuMedia.forEach(mediaItem => {
              mediaItem.classList.remove('mega-menu__media--on');
            });
  
            if (megaMenuDefaultMedia.length) {
              megaMenuDefaultMedia.forEach(defaultItem => {
                defaultItem.classList.remove('mega-menu__media--off');
              });
            }
  
            if (megaMenuTopLevelMedia.length) {
              megaMenuTopLevelMedia.forEach(topLevelItem => {
                topLevelItem.classList.remove('mega-menu__media--off');
              });
            }

            item.classList.remove('active');
          }, 500);
        });
      });
    }

    const megaMenuType2Links = document.querySelectorAll('.mega-menu__list--media-cards li[data-menu-item-id]');

    if (megaMenuType2Links.length) {
      megaMenuType2Links.forEach(item => {
        const link = item.querySelector('a');
        const id = item.dataset.menuItemId;

        if (link) {
          link.addEventListener('click', event => {
            if (item.classList.contains('active')) {
              return;
            }

            const megaMenuType2LinksActive = document.querySelectorAll('.mega-menu__list--media-cards li[data-menu-item-id].active');
            const grandChild = document.querySelector('.mega-menu__grand-list:not(.mega-menu__grand-list--active)[data-menu-parent-item-id="'+ id +'"]');
            const activeGrandChild = document.querySelector('.mega-menu__grand-list--active');

            if (grandChild) {
              event.preventDefault();
              clearTimeout(megaSubmenuTimeout2);

              if (activeGrandChild) {
                activeGrandChild.classList.remove('mega-menu__grand-list--visible');
              }

              megaSubmenuTimeout2 = setTimeout(()=>{
                if (activeGrandChild) {
                  activeGrandChild.classList.remove('mega-menu__grand-list--active');
                }
                
                grandChild.classList.add('mega-menu__grand-list--active');
                grandChild.classList.add('mega-menu__grand-list--visible');
              },500);
            }

            if (megaMenuType2LinksActive.length) {
              megaMenuType2LinksActive.forEach(activeItem => {
                activeItem.classList.remove('active');
              });
            }
            
            item.classList.add('active');
          });
        }
      });
    }
    
    window.addEventListener('resize', () => {
      const activeMegaMenu = document.querySelector('header-menu .mega-menu[open]');

      if (activeMegaMenu) {
        const activeMegaMenuItem = activeMegaMenu.querySelector('.header__menu-item');

        if (activeMegaMenuItem) {
          activeMegaMenuItem.dispatchEvent(new Event('click'));
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
